import React from 'react'

import { Tag } from '@/src/domains/design-system/components/Tag'

type Props = { children: React.ReactNode; className?: string }

const TherapistSpecializationBadge: React.FC<Props> = ({ children, className = '' }) => {
  return (
    <Tag variant="sand" size="s" className={className}>
      {children}
    </Tag>
  )
}

export default TherapistSpecializationBadge
